import React from "react"


// 子表单行数最大限制
export const SUBFORM_MAX_LIMIT = window.SUBFORM_MAX_LIMIT || 200;
export const APP_GROUP_TITLE_MAX_LIMIT = 64;

window.BsyConfig = null;
export function BsyConfig() {
    let t = "/template/formreport/static/css/resources/images/link_img_head/"
    if (window.BsyConfig) {
        return window.BsyConfig
    }

    return window.BsyConfig = {
        ...window.FX,

        RouteEnum: {
            RouteR1: window.rootDirectroy + "/", //工作台入口        
            RouteR2: window.rootDirectroy + "/team/apps", //全部应用
            RouteR3: window.rootDirectroy + "/team/group/:groupid", //应用分组
            RouteR4: window.rootDirectroy + "/team/app/:appid", //应用访问入口 
            RouteR5: window.rootDirectroy + "/team/app/:appid/:type/:entryid", //具体表单流程的访问入口  
            RouteR6: window.rootDirectroy + "/team/app/:appid/form/:entryid/data/:dataid/:type/:flowid", //流程消息 
            RouteR7: window.rootDirectroy + "/team/message/:id", //数据提交消息
            RouteR8: window.rootDirectroy + "/team/app/:appid/entry/:entryid/data/:dataid", //数据内联
            RouteR9: window.rootDirectroy + "/team/l/:id/data/:dataid", //数据外链
            RouteR10: window.rootDirectroy + "/team/app/:appid/entry/:entryid", //表单内链
            RouteR11: window.rootDirectroy + "/team/u/:id", //应用快捷入
            RouteR12: window.rootDirectroy + "/team/appinstall/:id", //应用快捷入口
            RouteR13: window.rootDirectroy + "/team/app/:appid/form/:entryid/datamanage", //应用快捷入口
            RouteR14: window.rootDirectroy + "/q/:innerlink", //公开查询
            TEAMTODO: window.rootDirectroy + "/team/todo", //流程待办   
            TEAMCC: window.rootDirectroy + "/team/cc", //流程待办   
            TEAMTRANSACTORS: window.rootDirectroy + "/team/transactors", //流程待办   
            TEAMCREATE: window.rootDirectroy + "/team/create", //流程待办   
            TEAMLAUNCH: window.rootDirectroy + "/team/launch", //流程待办  
        },

        appsExcludeRoute: [window.rootDirectroy + '/team/message/:id'],

        CONFIG: {
            HOST: {
                SITE_HOST: window._bby_config.site,
                SITE_SHORT_HOST: (window._bby_config.site || "").replace("www.", ""),
                IMAGE_HOST: "",
                ASSETS_HOST: window._bby_config.assets_site,
                OSS_IMAGE_HOST: "",
                HELP_DOC_HOST: window._bby_config.help_link,
                TRACK_HOST: "",
                OUTER_CHAIN_HOSTS: "",
                API_SITE: window._bby_config.api_site
            },
            COOKIE_DOMAIN: window._bby_config.cookie_domain
        },
        ValueWidgets: {
            text: 1,
            number: 1,
            textarea: 1,
            datetime: 1,
            checkboxgroup: 1,
            radiogroup: 1,
            combo: 1,
            combocheck: 1,
            address: 1,
            image: 1,
            upload: 1,
            subform: 1,
            user: 1,
            usergroup: 1,
            dept: 1,
            deptgroup: 1,
            location: 1,
            linkdata: 1,
            // linkquery: 1,
            // button: 1,
            // separator: 1,
            signature: 1,
            corresponding: 1,
            field: 1,
            filter: 1,
            filter_v1: 1,
            triggeraction: 1,
            triggeractionv1: 1,
            linkfield: 1,
            linkfieldv1: 1,
            linkfield_v2: 1,
            // dataload: 1,
            sn: 1,
            formsource: 1,
            //数据视图使用
            flowstate: 1,
        },
        FilterWidgets: {
            text: 1,
            number: 1,
            textarea: 1,
            datetime: 1,
            checkboxgroup: 1,
            radiogroup: 1,
            combo: 1,
            combocheck: 1,
            address: 1,
            user: 1,
            usergroup: 1,
            dept: 1,
            deptgroup: 1,
            location: 1,
            linkdata: 1,
            sn: 1
            // signature: 1,
            // image: 1,
            // upload: 1,
        },
        setValueWidgets: {
            text: 1,
            number: 1,
            textarea: 1,
            datetime: 1,
            checkboxgroup: 1,
            radiogroup: 1,
            combo: 1,
            combocheck: 1,
            address: 1,
            image: 1,
            upload: 1,
            subform: 1,
            user: 1,
            usergroup: 1,
            dept: 1,
            deptgroup: 1,
            location: 1,
            linkdata: 1,
            linkquery: 1,
            chargers: 1,
            flowState: 1,
            flowstate: 1,
            signature: 1,
            flowdecision: 1,
            sn: 1,
            formsource: 1,
        },
        ValueTypeMap: {
            text: "string",
            textarea: "string",
            combo: "string",
            radiogroup: "string",
            user: "id",
            combocheck: "array",
            checkboxgroup: "array",
            usergroup: "idarray",
            number: "number",
            datetime: "datetime",
            address: "address",
            location: "address",
            dept: "did",
            deptgroup: "didarray",
            upload: "upload",
            image: "upload",
            signature: "signature",
            creator: "id",
            sn: "string",
            formsource: 'string',
        },
        USER_ID: {
            CurrentUser: "100000000000000000000001",
            Creator: "100000000000000000000002",
        },
        DATA_PREFIX: {
            Aggregate: "2"
        },
        WidgetValueOption: {
            CUSTOM: 0,
            ASYNC: 1,
            RELY: 2,
            FORMULA: 3,
            WIDGET: 4,
            MODULE: 5
        },
        Keys: {
            ENTER: 13,
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38,
            ESC: 27,
            NUMBERS: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57],
            Z: 90,
            Y: 89,
            y: 121,
            V: 86
        },
        States: {
            NORMAL: 0,
            SUCCESS: 1,
            ERROR: 2,
            WARNING: 3
        },
        EntryAttributes: {
            creator: 1,
            createTime: 1,
            updateTime: 1,
            _id: 1,
            ext: 1
        },
        THEME: {
            DEFAULT_SYSTEM_THEME: "theme_0",
            DEFAULT_FORM_THEME: {
                title: {
                    "text-align": "left",
                    "font-size": 20,
                    "font-style": "normal",
                    "font-weight": "bold",
                    "text-decoration": []
                }
            },
            EXTERNAL_FORM_THEME: {
                theme_0: {
                    background: {
                        mode: "color",
                        color: "#F4F9F9"
                    },
                    banner: {
                        mode: "color",
                        color: "var(--bsy-base-color)"
                    },
                    title: {
                        color: "#ffffff",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "var(--bsy-base-color)"
                    }
                },
                theme_1: {
                    background: {
                        mode: "color",
                        color: "#000F3D"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi1.png"
                    },
                    title: {
                        color: "#344E9C",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#344E9C"
                    }
                },
                theme_2: {
                    background: {
                        mode: "color",
                        color: "#E9ECF3"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi2.png"
                    },
                    title: {
                        color: "#8398C1",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#8398C1"
                    }
                },
                theme_3: {
                    background: {
                        mode: "color",
                        color: "#E2F3FF"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi3.png"
                    },
                    title: {
                        color: "#7EC9FD",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#7EC9FD"
                    }
                },
                theme_4: {
                    background: {
                        mode: "image",
                        image: "#EDF7F1"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi4.png"
                    },
                    title: {
                        color: "#67C376",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#67C376"
                    }
                },
                theme_5: {
                    background: {
                        mode: "color",
                        color: "#DDF4FA"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi5.png"
                    },
                    title: {
                        color: "#65D3F1",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#65D3F1"
                    }
                },
                theme_6: {
                    background: {
                        mode: "color",
                        color: "#DFEAF6"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi6.png"
                    },
                    title: {
                        color: "#57A0F2",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#57A0F2"
                    }
                },
                theme_7: {
                    background: {
                        mode: "color",
                        color: "#DEF4F9"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi7.png"
                    },
                    title: {
                        color: "#5EC6E7",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#5EC6E7"
                    }
                },
                theme_8: {
                    background: {
                        mode: "color",
                        color: "#DCE0FE"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi8.png"
                    },
                    title: {
                        color: "#343E8E",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#343E8E"
                    }
                },
                theme_9: {
                    background: {
                        mode: "color",
                        color: "#FFF1F3"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi9.png"
                    },
                    title: {
                        color: "#FA98A1",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#FA98A1"
                    }
                },
                theme_10: {
                    background: {
                        mode: "color",
                        color: "#2C224D"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi10.png"
                    },
                    title: {
                        color: "#3D1E93",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#3D1E93"
                    }
                },
                theme_11: {
                    background: {
                        mode: "color",
                        color: "#E0EDFF"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi11.png"
                    },
                    title: {
                        color: "#4E6A9B",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#4E6A9B"
                    }
                },
                theme_12: {
                    background: {
                        mode: "color",
                        color: "#EDF7F4"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi12.png"
                    },
                    title: {
                        color: "#548A72",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#548A72"
                    }
                },
                theme_13: {
                    background: {
                        mode: "color",
                        color: "#FAF4E8"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi13.png"
                    },
                    title: {
                        color: "#F0B36C",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#F0B36C"
                    }
                },
                theme_14: {
                    background: {
                        mode: "color",
                        color: "#D7EEF8"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi14.png"
                    },
                    title: {
                        color: "#5ABCF2",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#5ABCF2"
                    }
                },
                theme_15: {
                    background: {
                        mode: "color",
                        color: "#E6EBF9"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi15.png"
                    },
                    title: {
                        color: "#A4B3EA",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#A4B3EA"
                    }
                },
                theme_16: {
                    background: {
                        mode: "color",
                        color: "#D3E8EE"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi16.png"
                    },
                    title: {
                        color: "#005D89",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#005D89"
                    }
                },
                theme_17: {
                    background: {
                        mode: "color",
                        color: "#F5F0F0"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi17.png"
                    },
                    title: {
                        color: "#A49A9E",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#A49A9E"
                    }
                },
                theme_18: {
                    background: {
                        mode: "color",
                        color: "#F7EbE4"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi18.png"
                    },
                    title: {
                        color: "#C89C79",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#C89C79"
                    }
                },
                theme_19: {
                    background: {
                        mode: "color",
                        color: "#EEE2E3"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi19.png"
                    },
                    title: {
                        color: "#A77072",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#A77072"
                    }
                },
                theme_20: {
                    background: {
                        mode: "color",
                        color: "#FBF4E6"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi20.png"
                    },
                    title: {
                        color: "#4F7EF0",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#4F7EF0"
                    }
                },
                theme_21: {
                    background: {
                        mode: "color",
                        color: "#E3F5FC"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi21.png"
                    },
                    title: {
                        color: "#7AC4F4",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#7AC4F4"
                    }
                },
                theme_22: {
                    background: {
                        mode: "color",
                        color: "#F9E7D9"
                    },
                    banner: {
                        mode: "image",
                        image: t + "img_biaodanyangshi22.png"
                    },
                    title: {
                        color: "#E09556",
                        display: "block"
                    },
                    submit_btn: {
                        "background-color": "#E09556"
                    }
                }
            }
        },
        Time: {
            excelDayOffset: 25569,
            millisecondsOfDay: 864e5
        },
        TimeZone: {
            defaultOffset: 288e5
        },
        Events: {
            RELY: "x-rely"
        },
        InvisibleSubmitRules: {
            KEEP: 1,
            NULL: 2,
            ALWAYS: 3
        },

        LimitFields: {
            systemFields: ["creator", "createTime", "updateTime", '_id', "flowState", "chargers", "ext"],
            dataManage: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "image", "upload", "signature", "subform", "linkdata", "sn", "phone"],
            dashCustomSort: ['_id', "text", "radiogroup", "combo", "sn", "ext"],
            queryFilter: ['_id', "text", "radiogroup", "combo", "number", "datetime", "user", 'sn', 'address'],
            sort: ['_id', "text", "number", "radiogroup", "datetime", "combo", "linkdata", "sn"],
            flowQueryPaneFilter: ['_id', "text", "radiogroup", "combo", "number", "datetime", "address", "user", "dept", 'sn'],
            parameter: ['_id', "text", "radiogroup", "combo", "number", "datetime", "address", "user", "dept", "subform", "flowstate", "flowdecision", 'sn'],
            filter: ['_id', "text", "textarea", "radiogroup", "checkboxgroup", "combo", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "flowState", "flownode", "flowdecision", "subform", 'sn', "image", "upload", "signature"],
            Notifyfilter: ['_id', "text", "textarea", "radiogroup", "checkboxgroup", "combo", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", 'sn'],
            Notifyfield: ['_id', "flowstate", "text", "textarea", "radiogroup", "checkboxgroup", "combo", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", 'sn'],
            list: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "image", "upload", "subform", "linkdata", "signature", "flowState", "flowdecision", "chargers", 'sn', 'flowstate'],
            listJoin: ['_id', "text", "combo", "radiogroup", "number", "user", "dept", 'sn'],
            group: ['_id', "text", "radiogroup", "combo", "number", "datetime", "address", "string", "subform", "user", "dept", "id", "location", "linkdata", "flowState", "flowdecision", 'sn'],
            subGroup: ['_id', "text", "combo", "number", "datetime", "radiogroup", "combo", 'user', "dept"],
            dataLabel: ['_id', "text", "number", "datetime", "radiogroup", "checkboxgroup", "combo", "combocheck", "address", "location", "user", "usergroup", "dept", "deptgroup", "sn", "phone"],
            groupJoin: ['_id', "text", "combo", "radiogroup", "number", "user", "datetime", "address", "location", "subform", "linkdata", "dept", 'sn'],
            subGroupJoin: ['_id', "text", "combo", "number", "datetime", "linkdata"],
            validate: ['_id', "number", "text", "datetime", "radiogroup", "checkboxgroup", "combo", "combocheck", "user", "usergroup", "linkdata", "dept", "deptgroup", "subform"],
            rely: ['_id', "combo", "combocheck", "textarea", "text", "datetime", "number", "subform", "radiogroup", "checkboxgroup", "user", "linkdata", "dept", "address", "deptgroup", "usergroup", "image", "upload", "signature"],
            link: ['_id', "combo", "combocheck", "text", "datetime", "number", "radiogroup", "checkboxgroup", "user", "linkdata", "dept", "deptgroup", "usergroup", "address"],
            brief: ['_id', "text", "textarea", "combo", "radiogroup", "combocheck", "checkboxgroup", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", 'sn'],
            import: ['_id', "text", "textarea", "combo", "radiogroup", "combocheck", "checkboxgroup", "number", "datetime", "address", "subform", 'user', 'dept', 'usergroup', 'deptgroup', "sn", 'image'],
            combodata: ['_id', "combo", "combocheck", "text", "datetime", "number", "radiogroup", "checkboxgroup", 'sn'],
            linkData: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "subform", "image", "upload", "signature", 'sn'],
            linkKey: ['_id', "text", "number", "datetime", "radiogroup", "combo", 'sn'],
            subLinkData: ['_id', "text", "combo", "combocheck", "radiogroup", "checkboxgroup", "number", "datetime", "address", "location"],
            aggregate: ['_id', "text", "radiogroup", "combo", "string", "subform", 'sn', 'user', "dept"],
            batchEdit: ['_id', "number", "text", "textarea", "datetime", "radiogroup", "checkboxgroup", "combo", "combocheck", "address", "user", "usergroup", "dept", "deptgroup"],
            fileExport: ["image", "upload", "signature"],
            itemLink: ["combo", "radiogroup"],
            fieldQrcode: ['_id', "text", "sn"],
            printTemplate: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "subform", "linkdata", "linkquery", "flow", "image", "signature", 'sn', 'qrcode', "creator", "createTime", "updateTime",
                "flowstate", "chargers", "flowdecision", "innerlink_qr", "publiclink_qr", "flow_signature", "flow_comment",
                "flow_comment", "flow_state", "flow_decision", "flow_nodes", "flow_chargers", "innerlink_qr", "publiclink_qr", "print_operator", "print_time", "form_publink_qr"
            ],
            printTemplateCellEditField: ['_id', "text", "textarea", "number", "datetime", "radiogroup", "checkboxgroup", "combo", "combocheck", "address", "location", "user", "usergroup", "dept", "deptgroup", "sn",
                "flow_chargers", "flow_nodes", "flow_decision", "flow_state"
            ],
            excelExport: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "subform", "linkdata", 'sn', "image", "signature", "upload"],
            noCache: ["location", "separator", "linkquery"],
            ext: ['_id', "text", "textarea", "number", "radiogroup", "combo", 'sn'],
            userDept: ['_id', "user", "usergroup", "dept", "deptgroup"],
            triggerWrite: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "image", "upload", 'sn', "signature"],
            etlInput: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "subform", "sn", "image", "upload", "signature", "flowstate"],
            etlMapFormula: ["number"],
            etlDimension: ['_id', "text", "radiogroup", "checkboxgroup", "combo", "combocheck", "datetime", "address", "subform", "user", "dept", "usergroup", "deptgroup", "location", "sn", "flowstate"],
            etlQuota: ['_id', "text", "combo", "radiogroup", "datetime", "address", "location", "number", "user", "dept", "subform", "sn", "formula", "flowState", "image", "upload", "signature", 'flowstate'],
            dashTableFormula: ["number"],
            dashSort: ['_id', "text", "number", "radiogroup", "datetime", "combo", "sn", "formula", "flowstate", "flowState", "flowdecision"],
            dashTextAlignment: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "sn", "flowstate", 'formula'],
            dashDimension: ['_id', "text", "radiogroup", "checkboxgroup", "combo", "combocheck", "datetime", "address", "subform", "user", "dept", "usergroup", "deptgroup", "location", "sn", "flowState", "flowstate"],
            dashDimensions: ['_id', "text", "number", "radiogroup", "checkboxgroup", "combo", "combocheck", "datetime", "address", "subform", "user", "dept", "usergroup", "deptgroup", "location", "sn", "flowState", "flowstate"],
            dashDimensionTime: ["datetime"],
            dashDimensionLAL: ["location", "text"],
            dashQuota: ['_id', "text", "combo", "radiogroup", "datetime", "address", "location", "number", "user", "dept", "subform", "sn", "formula", "flowstate", "flowState"],
            dashFilter: ['_id', "text", "radiogroup", "checkboxgroup", "combo", "combocheck", "datetime", "address", "user", "dept", "usergroup", "deptgroup", "location", "number", "sn", "flowState", "flowstate"],
            dashFilters: ['_id', "text", "textarea", "radiogroup", "checkboxgroup", "combo", "combocheck", "datetime", "address", "user", "dept", "usergroup", "deptgroup", "location", "number", "sn", "flowState", "flowstate"],
            dashField: ['_id', "text", "number", "radiogroup", "checkboxgroup", "combo", "combocheck", "datetime", "address", "subform", "user", "dept", "usergroup", "deptgroup", "location", "linkdata", "sn", "flowstate", "flowState"],
            dashGanttField: ['_id', "text", "textarea", "number", "radiogroup", "combo", "checkboxgroup", "combocheck", "datetime", "address", "subform", "user", "dept", "usergroup", "deptgroup", "usergroup", "deptgroup", "location", "linkdata", 'linkquery', "image", "upload", "signature", "sn", "flowState", "phone", 'chargers', "flowdecision", "flowstate", "flowState", "button", "dataload", "separator"],
            dashFields: ['_id', "text", "textarea", "signature", "upload", "image", "number", "radiogroup", "checkboxgroup", "combo", "combocheck", "datetime", "address", "subform", "user", "dept", "usergroup", "deptgroup", "location", "linkdata", "sn", "flowstate", "flowState"],
            datahelperFields: ['_id', "text", "textarea", "signature", "upload", "image", "number", "radiogroup", "checkboxgroup", "combo", "combocheck", "datetime", "address", "subform", "user", "dept", "usergroup", "deptgroup", "location", "sn", "flowstate", "flowState"],
            dashTableField: ['_id', "text", "textarea", "number", "radiogroup", "combo", "checkboxgroup", "combocheck", "datetime", "address", "subform", "user", "dept", "usergroup", "deptgroup", "usergroup", "deptgroup", "location", "linkdata", "formula", "image", "upload", "signature", "sn", "flowState", "phone", 'chargers', "flowdecision", "flowstate", "flowState", "button", "dataload", "separator"],
            // dashTableField: ["text", "textarea", "number", "radiogroup", "combo", "checkboxgroup", "combocheck", "datetime", "address", "subform", "user", "dept", "usergroup", "deptgroup", "usergroup", "deptgroup", "location", "linkdata", "formula", "image", "upload", "signature", "sn", "flowState", "phone",'chargers',"flowdecision","flowstate","flowState"],
            multipleField: ["checkboxgroup", "combocheck", "usergroup", "deptgroup "],
            multipleFields: [],
            dashCardShowField: ['_id', "formula", "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "linkdata", "flowState", "flowdecision", "chargers", 'sn', 'flowstate'],
            dashCardTitleField: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "linkdata", "flowState", "flowdecision", "chargers", 'sn', 'flowstate', "image"],
            dashTableFilter: ['_id', "text", "textarea", "radiogroup", "checkboxgroup", "combo", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "image", "upload", "signature", "sn", "flowState", 'flowstate', "phone", "flowdecision"],
            triggerQuery: ['_id', "text", "textarea", "radiogroup", "checkboxgroup", "combo", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "image", "upload", "signature", "sn"],
            triggerCond: ['_id', "text", "textarea", "combo", "radiogroup", "checkboxgroup", "combocheck", "number", "datetime", "address", "location", "user", "usergroup", "dept", "deptgroup", "flowstate", "sn", "signature", "image", "upload"],
            datahelpnews: ['_id', "text", "combo", "radiogroup", "user", "usergroup", "dept", "deptgroup"],
            disable: ['_id', "text", "textarea", "number", "datetime", "radiogroup", "checkboxgroup", "combo", "combocheck", "address", "location", "phone"],
            dashCompFilter: ["text_filter", "textarea_filter", "combocheck_filter", "user_filter", "usergroup_filter", "number_filter", "address_filter", "date_filter", "datetime_filter", "datemonth_filter", "dateyear_filter", "dept_filter", "deptgroup_filter", "flowstate_filter", "phone_filter", "filelist_filter", "address_city_filter", "address_district_filter", "address_province_filter", 'assist_prostatus_filter', 'assist_prostatus_filter', 'assist_flowid_filter','flowdecision_filter'],
            dashCompChart: ["metric_table", "gauge_chart", "data_table", "rili", "pivot_table", "line_chart", "column_chart", "bar_chart", "funnel_chart", "area_chart", "pie_chart", "radar_chart", "calendar_manage", "data_manage"],
            dashRowOrderChart: ["data_table", "pivot_table", "rili", 'background_table'],
            dashTopDataChart: ["metric_table", "gauge_chart", "data_table", "rili", "pivot_table", "funnel_chart", "column_chart", "bar_chart", "pie_chart", "multi_axes_chart", 'background_table'],
            dashCustomAxisLabelChart: ["line_chart", "column_chart", "area_chart", "multi_axes_chart"],
            dashCustomAxisRangeChart: ["line_chart", "column_chart", "bar_chart", "area_chart", "multi_axes_chart"],
            dashAxisChart: ["line_chart", "gauge_chart", "column_chart", "bar_chart", "funnel_chart", "area_chart", "radar_chart", "multi_axes_chart"],
            dashThresholds: ["metric_table", "gauge_chart", "pivot_table", "line_chart", "column_chart", "funnel_chart", "bar_chart", "multi_axes_chart"],
            dashGuideline: ["line_chart", "column_chart", "bar_chart", "area_chart", "multi_axes_chart"],
            dashColors: ["line_chart", "column_chart", "bar_chart", "funnel_chart", "area_chart", "pie_chart", "radar_chart", "multi_axes_chart", "map_chart", 'gantt'],
            dashChartLabel: ["line_chart", "column_chart", "bar_chart", "funnel_chart", "area_chart", "pie_chart", "radar_chart", "multi_axes_chart", "map_chart"],
            dashLegend: ["line_chart", "column_chart", "bar_chart", "funnel_chart", "area_chart", "pie_chart", "radar_chart", "multi_axes_chart", "gantt"],
            dashChangedColors: ["line_chart", "column_chart", "bar_chart", "funnel_chart", "area_chart", "radar_chart", "multi_axes_chart", "gantt"],
            dashMobileLayout: ["metric_table", "gauge_chart", "newMap", "data_table", "pivot_table", "line_chart", "column_chart", "funnel_chart", "bar_chart", "area_chart", "pie_chart", "radar_chart", "rili", "calendar_manage", "data_manage", "multi_axes_chart", "map_chart", "description", 'background_table', "gantt"],
            invisibleFieldFilter: ['_id', "text", "textarea", "number", "datetime", "combo", "combocheck", "radiogroup", "checkboxgroup", "address", "location", "image", "upload", "linkfield", "signature", "phone", "user", "usergroup", "dept", "deptgroup", "subform"],
            fieldVisibleFilter: ['_id', "text", "textarea", "datetime", "number", "combo", "combocheck", "radiogroup", "checkboxgroup", "address", "location", "image", "upload", "signature", "phone", "user", "usergroup", "dept", "deptgroup", 'tabs']
        },
        Operators: {
            group: ["+", "-", "*", "/", "."],
            aggregate: ["+", "-", "."]
        },
        CONST: {
            DATE_FILTER_FORMULA_MODE: {
                CUSTOM: "custom",
                PRESET: "preset"
            },
            DATE_FILTER_FORMULA_MAP: {
                today: "1d",
                yesterday: "-1d",
                tomorrow: "+1d",
                thisWeek: "1w",
                lastWeek: "-1w",
                nextWeek: "+1w",
                thisMonth: "1M",
                lastMonth: "-1M",
                nextMonth: "+1M",
                thisQuarter: "1Q",
                lastQuarter: "-1Q",
                nextQuarter: "+1Q",
                thisYear: "1y",
                lastYear: "-1y",
                nextYear: "+1y"
            },
            DATE_FILTER_FORMULA_UNIT: {
                DAY: "d",
                WEEK: "w",
                MONTH: "M",
                QUARTER: "Q",
                YEAR: "y"
            },
            TRIGGER_TYPE_EQUAL: {
                text: "text",
                radiogroup: "text",
                combo: "text",
                sn: "text",
                textarea: "multitext",
                number: "number",
                checkboxgroup: "textarray",
                combocheck: "textarray",
                datetime: "datetime",
                image: "image",
                upload: "upload",
                signature: "signature",
                address: "address",
                location: "location",
                user: "user",
                usergroup: "userarray",
                dept: "dept",
                deptgroup: "deptarray",
                flowstate: "flowstate"
            },
            FIELD_VISIBLE_RULE: {
                RULE_MAX: 200,
                COND_MAX: 50
            },
            FLOW_FAIL_HINT: {
                forwardfail: React.language("flow.fail.hint.forward"),
                backfail: React.language("flow.fail.hint.back"),
                autoforwardfail: React.language("flow.fail.hint.autoForward"),
                autobackfail: React.language("flow.fail.hint.autoBack")
            },
            PRINT_DPI: 96,
            FLOW_FAIL_CODE: {
                FORWARD_CHARGER: 5008,
                BACK: 5009,
                FORWARD_COND: 5011,
                FORWARD_SUBFLOW: 5044,
                FORWARD_approval: 5045,
            },
            ETL_STATUS: {
                SUCCESS: "success",
                FAILURE: "failure",
                RUNNING: "running"
            },
            FLOW_STATE_FIELD: {
                type: "flowState",
                name: "flowState",
                text: React.language("field.flowState")
            },
            SORT: {
                ASC: 1,
                DESC: -1,
                DEFAULT: 0
            },
            DASH_SORT_ERROR: {
                MAX_COUNT: 6,
            },
            FLOW_ACTION: {
                FORWARD: "forward",
                AUTO_FORWARD: "auto_forward",
                AUTO_APPROVE: "auto_approve",
                BATCH_FORWARD: "batch_forward",
                script_close: "script_close",
                script_forward: "script_forward",
                webapi_forward: "webapi_forward",
                import_forward: "import_forward",
                END: "end",

            },
            ALIGNMENT: {
                LEFT: "h-left",
                RIGHT: "h-right",
                CENTER: "h-center",
                DEFAULT: "",
            },
            INVALID_TYPE: {
                INVALID: 1,
                REGEX: 2,
                BLANK: 3,
                REPEAT: 4,
                OUTSIDE: 5,
                COUNTING: 6,
                RANGE: 7,
                SMS: 8,
                PHONE_REGEX: 9,
                PHONE_TIMEOUT: 10,
                FILE_UPLOADING: 11
            },
            DASHBOARDTYPE: {
                WORKSPACE: "workspace",
                APPEDIT: "appedit",
                FORMEDIT: "formedit",
                REPORTEDIT: "reportedit",
                AGGREGATEEDIT: "aggregateedit",
                ACCOUNT: "account",
                VISIT: "visit",
                MYMODULE: "mymodule",
                MODULE: "module",
                MODULEEDIT: "moduleEdit",
                TEMPLATEVISIT: "templatevisit",
                APPSTORE: "appstore",
                PAY: "pay",
                ETL: "etl",
                DATAHELPER: "datahelper",
                DASH: "dash"
            },
            SEP_LINE_STYLE: {
                NONE: "none",
                DASHED: "dashed",
                THIN: "thin",
                THICK: "thick"
            },
            FILTER_FLOW_STATE_FIELD: {
                type: "flowstate",
                name: "flowState",
                text: React.language("field.flowState")
            },
            API_VALUE_TYPE_MAP: {
                sn: "string",
                text: "string",
                textarea: "string",
                number: "number",
                datetime: "string",
                radiogroup: "string",
                checkboxgroup: "array",
                combo: "string",
                combocheck: "array",
                address: "json",
                location: "json",
                linkdata: "json",
                user: "json",
                usergroup: "array",
                dept: "json",
                deptgroup: "array",
                image: "array",
                upload: "array",
                signature: "json",
                flowState: "number",
                subform: "array",
                phone: "json"
            },
            DATE_FORMATS: {
                yyyy: "2015",
                yyyyMM: "201501",
                "yyyy-MM": "2015-01",
                "yyyy/MM": "2015/01",
                yyyyMMdd: "20150131",
                "yyyy-MM-dd": "2015-01-31",
                "yyyy/MM/dd": "2015/01/31",
                MMdd: "0131",
                "MM-dd": "01-31",
                "MM/dd": "01/31"
            },
            WEBHOOK: {
                API_TRIGGER: {
                    CREATE: "data_create",
                    UPDATE: "data_update",
                    REMOVE: "data_remove",
                    RECOVER: "data_recover",
                    FORM_UPDATE: "form_update"
                },
                SERVER_TYPE: {
                    FR: "fr",
                    CUSTOM: "custom"
                }
            },
            LIMIT_FORMULA: {
                etl_map: ["ABS", "AVERAGE", "CEILING", "FLOOR", "INT", "MAX", "MIN", "MOD", "POWER", "ROUND", "SQRT", "AND", "FALSE", "IF", "IFS", "NOT", "OR", "TRUE", "XOR"]
            },
            DASH_AGGREGATE_FUNC: ["SUM", "AVERAGE", "MAX", "MIN", "COUNT"],
            MEMBER_ASYNC_STATE: {
                SUCCESS: 0,
                FAILED: 1,
                SYNCING: 2
            },

            MEMBER_INVITE_STATUS: {
                JOINED: 1,
                INVITING: 0
            },
            DEPARTMENT_ROOT: 1,
            CONTACT_ALL_GROUP: "1",
            COMMON_REG: {
                VALIDATOR_FORMULA: /(\$[0-9a-zA-Z._]+#)/g,
                FORM_FORMULA: /(\$[0-9a-zA-Z._#@]+)/g
            },
            FILTER_RELATION: {
                AND: "and",
                OR: "or"
            },
            DIMENSION_GROUP: {
                ADDRESS: [{
                    text: React.language("province"),
                    value: "province"
                }, {
                    text: React.language("dash.dimension.provinceCity"),
                    value: "province_city"
                }, {
                    text: React.language("dash.dimension.provinceCityDistrict"),
                    value: "province_city_district"
                }],
                DATE: [{
                    text: React.language("year"),
                    value: "year"
                }, {
                    text: React.language("dash.dimension.yearQuarter"),
                    value: "year_quarter"
                }, {
                    text: React.language("dash.dimension.yearMonth"),
                    value: "year_month"
                }, {
                    text: React.language("dash.dimension.yearWeek"),
                    value: "year_week"
                }, {
                    text: React.language("dash.dimension.yearMonthDay"),
                    value: "year_month_day"
                }]
            },
            TRIGGER: {
                TRIGGERS: {
                    CREATE: "data_insert",
                    UPDATE: "data_update",
                    REMOVE: "data_delete",
                    RELY: "data_rely",
                    MODULE: "data_module",
                    DATANEWS: "data_news",
                    SUBFORMRELY: "subform_rely",
                },
                EDIT_MODE: {
                    FORM: "data_to_form",
                    SUBFORM: "data_to_subform",
                    SUBFORM2FORM: "subform_to_data",
                    SUBFORM2SUBFORM: "subform_to_subform",
                    DELETEFORM: "delete_form",
                    DELETESUBFORM: "delete_subform",
                    RELYFORM: "darerely_form",
                    RELYSUBFORM: "darerely_subform",
                    UPDATEREPLACESUBFORM: "replace_subform",
                    CUSTOM: "custom",
                    DATA2NEWS: "data_to_news",
                    DATAS2NEWS: "datas_to_news",
                    SUBFORMRELY: "subform_to_rely",
                    SUBFORMFIXRELY: "subform_fix_rely",
                    SUBFORMADD: "subform_add",
                    SUBFORMDELETE: "subform_delete",
                },
                EXE: {
                    CREATE: "insert_data",
                    UPDATE: "update_data",
                    REMOVE: "delete_data",
                    RELY: "rely_data",
                    NEWS: "news_data",
                    SUBFORMRELY: "rely_subform"
                },
                STEP: {
                    TRIG: 1,
                    EXE: 2,
                    OTHER: 3,
                    UPDATEINSERT: 4,
                    MODULE: 5,
                    RELYDEFAULT: 6,
                    DATANEWS: 7,
                    SUBFORMRELY: 8,
                }
            },
            DASH_FIELD_RANGE_PRESET_COLOR: ["#63B2EE", "#76DA91", "#F8CB7F", "#F89588", "#7CD6CF", "#9192AB", "#7898E1", "#EFA666", "#EDDD86", "#9987CE"],
            DASH_STYLE_LIGHT: ["preset_style_light_1"],
            DASH_STYLE_DARK: ["preset_style_dark_1", "preset_style_dark_2", "preset_style_dark_3"],
            DASH_STYLE_COLOR: {
                preset_style_light_1: {
                    color: ["#F4F6F9", "#FFFFFF", "#F3F6FC", "#E1E9F8"],
                    highLightColor: "var(--bsy-base-color)",
                    tableColor: "#E9E9E9"
                },
                preset_style_dark_1: {
                    color: ["#111121", "#1A2038", "#29314C", "#3C486C"],
                    highLightColor: "#2770E5",
                    tableColor: "#384C8E"
                },
                preset_style_dark_2: {
                    color: ["#0F0E27", "#19173B", "#282651", "#3C3974"],
                    highLightColor: "#A142C6",
                    tableColor: "#4F3A85"
                },
                preset_style_dark_3: {
                    color: ["#04122f", "#143654", "#0D2D59", "#3A67A6"],
                    highLightColor: "#8095FF",
                    tableColor: "#005297"
                }
            },
            DASH_STYLE_DARK_COLOR: ["rgba(255, 255, 255, 0.92)", "rgba(255, 255, 255, 0.68)", "rgba(255, 255, 255, 0.4)", "rgba(255, 255, 255, 0.26)"],
            DASH_STYlE_LIGHT_COLOR: ["#1F2D3D", "#5E6D82"],
            DASH_STYLE_OPTION_PRESET_COLORS: ["#E7E7E7", "#909AB8", "#B1D5DD", "#D2DDC0", "#DAC1DF", "#EEB7C2", "#C2C2C2", "#3C486C", "#7EA9B3", "#9DAB84", "#AF84B9", "#D68494", "#969696", "#111121", "#497884", "#617444", "#7C4988", "#B74B61"],
            MAX_COUNT: 1e5,
            MAX_TODO_COUNT: 999,
            MAX_FORMULA_FIELD: 80,
            MAX_FORMULA_OPERATOR: 80,
            MAX_DASH_SORT_COUNT: 5,
            MAX_DASH_CUSTOM_SORT_COUNT: 5,
            MAX_FILE_SIZE: 20971520,
            FIELD_LINE_WIDTH: 12,
            NUM_DISPLAY: {
                NUMBER: "number",
                PERCENT: "percent"
            },
            NUM_FIX_PRECISION: {
                NUMBER: 6,
                PERCENT: 4
            },
            NUM_DEFAULT_PRECISION: {
                NUMBER: 8,
                PERCENT: 6
            },
            VIP_ERR_NAME_MAP: {
                DATA_BACKUP: 7121,
                FILE_ZIP: 7122,
                SUBMIT_PROMPT: 7125,
                DATA_API: 7120,
                PRINT: 7112,
                SIGNATURE: 7130,
                TRIGGER_NO: 7134,
                TRIGGER_LIMIT: 7135,
                CUSTOM_THEME: 7139,
                CUSTOM_LOGIN: 7140,
                SSO: 7141,
                THRESHOLD: 7142
            },
            COOKIE: {
                NEED_REM: {
                    KEY: "needRem",
                    EXPIRES_DATE: new Date((new Date()).getTime() + 31536e6)
                },
                PHONE: {
                    KEY: "bind_phone",
                    EXPIRES: new Date((new Date()).getTime() + 864e5),
                    VALUE: !0
                },
                GUIDE: {
                    SUFFIX_KEY: "#guide",
                    EXPIRES_DATE: new Date((new Date()).getTime() + 31536e6),
                    TYPE: {
                        APP_EDIT: 1,
                        APP_EDIT_MENU: 2
                    }
                },
                HELP_ONLINE: {
                    KEY: "help_online",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6)
                },
                USER_GUIDE_BTN: {
                    KEY: "user_guide_btn",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6)
                },
                USER_GUIDE: {
                    KEY: "user_guide",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6),
                    VALUE: !0
                },
                FORM_GUIDE: {
                    KEY: "form_guide",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6),
                    VALUE: !0
                },
                DASH_CHART_GUIDE: {
                    KEY: "dash_chart_guide",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6),
                    VALUE: !0
                },
                DOT_GUIDE: {
                    KEY: "dot_guide",
                    EXPIRES: new Date((new Date()).getTime() + 2592e6),
                    VALUE: {
                        ETL_INTRO: 128,
                        MEI_QIA: 64,
                        FLOW_FILTER_PART: 32,
                        FLOW_FILTER_CREATE: 16,
                        FLOW_FILTER_TODO: 8,
                        DATA_FILTER: 4,
                        APP_SET: 2,
                        DASH_BOARD: 1
                    }
                },
                STEP_GUIDE: {
                    KEY: "step_guide",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6),
                    VALUE: {
                        HELP_CENTER: 21,
                        FLOW_LAUNCH: 20,
                        FLOW_CHARGER: 19,
                        FLOW_NODE: 18,
                        FLOW_DESIGN: 17,
                        DATA_AUTH: 16,
                        SHARE_INTRO: 15,
                        SHARE_FORM: 14,
                        SAVE_FORM: 13,
                        EDIT_WIDGET: 12,
                        ADD_WIDGET: 11,
                        FORM_RENAME: 10,
                        DASHBOARD: 6,
                        MENU: 5,
                        FORM_VISIT: 4,
                        APP_VISIT: 3,
                        FORM_EDIT: 2,
                        APP_EDIT: 1,
                        BEGIN: 0
                    }
                },
                GIFT: {
                    KEY: "gift-coupon",
                    EXPIRES: new Date((new Date()).getTime() + 6048e5)
                },
                ACTIVITY: {
                    KEY: "activity",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6),
                    VALUE: "1"
                },
                PERSONA: {
                    SUFFIX_KEY: "#user_portrait",
                    EXPIRES: new Date((new Date()).getTime() + 2592e5),
                    VALUE: !0
                },
                MUTE_PERSONA: {
                    SUFFIX_KEY: "#mute_user_portrait",
                    EXPIRES: new Date((new Date()).getTime() + 2592e6),
                    VALUE: !0
                },
                RECOMMEND: {
                    SUFFIX_KEY: "#recommend_apps",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6),
                    VALUE: !0
                },
                INVITE_MEMBER: {
                    SUFFIX_KEY: "#invite_member",
                    EXPIRES: new Date((new Date()).getTime() + 2592e6),
                    VALUE: !0
                },
                PUBLISH_TIP: {
                    KEY: "publish_tip",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6),
                    VALUE: "1"
                },
                FX_LANG: {
                    KEY: "fx-lang",
                    EXPIRES: new Date((new Date()).getTime() + 6048e5)
                },
                THRESHOLD_BROADCAST: {
                    KEY: "threshold_broadcast",
                    EXPIRES: new Date((new Date()).getTime() + 31536e6),
                    VALUE: !0
                }
            },
            WIDGET_LIST: {
                text: {
                    name: React.language("widget.text"),
                    changeList: ["combo", "radiogroup"],
                    subChangeList: ["combo"]
                },
                radiogroup: {
                    name: React.language("widget.radiogroup"),
                    changeList: ["combo", "text"]
                },
                combo: {
                    name: React.language("widget.combo"),
                    changeList: ["radiogroup", "text"],
                    subChangeList: ["text"]
                },
                subform_text: {
                    name: React.language("widget.text"),
                    changeList: ["combo", "radiogroup"],
                    subChangeList: ["combo"]
                },
                subform_radiogroup: {
                    name: React.language("widget.radiogroup"),
                    changeList: ["combo", "text"]
                },
                subform_combo: {
                    name: React.language("widget.combo"),
                    changeList: ["radiogroup", "text"],
                    subChangeList: ["text"]
                },
                checkboxgroup: {
                    name: React.language("widget.checkboxgroup"),
                    changeList: ["combocheck"]
                },
                combocheck: {
                    name: React.language("widget.combocheck"),
                    changeList: ["checkboxgroup"]
                },
                number: {
                    name: React.language("widget.number")
                },
                datetime: {
                    name: React.language("datetime")
                },
                address: {
                    name: React.language("widget.address")
                },
                textarea: {
                    name: React.language("widget.textarea")
                },
                image: {
                    name: React.language("form.theme.image")
                },
                upload: {
                    name: React.language("widget.upload")
                },
                subform: {
                    name: React.language("etl.input.subform")
                },
                separator: {
                    name: React.language("widget.separator")
                },
                button: {
                    name: React.language("buttom.print.auth")
                },
                user: {
                    name: React.language("widget.user")
                },
                usergroup: {
                    name: React.language("widget.usergroup")
                },
                location: {
                    name: React.language("widget.location")
                },
                linkdata: {
                    name: React.language("widget.linkdata")
                },
                linkquery: {
                    name: React.language("widget.linkquery")
                },
                dept: {
                    name: React.language("widget.dept")
                },
                deptgroup: {
                    name: React.language("widget.deptgroup")
                },
                signature: {
                    name: React.language("app.category.signature"),
                    // mode: 'beta'
                },
                sn: {
                    name: React.language("widget.sn"),
                },
                dataload: {
                    name: React.language("data.loading"),
                },
                field: {
                    name: React.language("field"),
                },
                corresponding: {
                    name: React.language("corresponding.field"),
                },
                linkfield: {
                    name: React.language("field.link"),
                },
                filter: {
                    name: React.language("dash.cond"),
                },
                filter_v1: {
                    name: React.language("dash.cond"),
                },
                linkfield_v2: {
                    name: React.language("field.link"),
                },
                triggeraction: {
                    name: React.language("old.perform.action"),
                },
                triggeractionv1: {
                    name: React.language("perform.action"),
                },
                linkfieldv1: {
                    name: React.language("field.link"),
                },
                formsource: {
                    name: React.language("form.source"),
                }
            },
            FLOW_ACTION_NAME: {
                back: React.language("flow.action.back"),
                close: React.language("flow.action.close"),
                forward: React.language("submit"),
                print: React.language("flow.action.print"),
                revoke: React.language("flow.action.revoke"),
                save: React.language("flow.action.save"),
                transfer: React.language("flow.action.transfer"),
                batchForward: React.language("flow.batch.forward")
            },
            SYSTEM_FIELD_ALIAS: [
                "_id",
                "creator",
                "createTime",
                "updateTime",
                "deleter",
                "deleteTime",
                "flowState",
                "chargers",
                "flowDecision",
                "submit",
                "authority",
                "id",
                "tabs",
            ],
            APP_CATE_NAME: {
                office: "行政办公",
                hr: "人力资源",
                crm: React.language("app.category.crm"),
                inventory: React.language("app.category.inventory"),
                store: React.language("app.category.store"),
                production: React.language("app.category.production"),
                universal_other: React.language("other"),
                logistics: "物流快递",
                restaurant: "餐饮",
                it: React.language("app.category.it"),
                housing: "房产物业",
                education: React.language("app.category.education"),
                medicine: "医疗卫生",
                government: "政府机关",
                vertical_other: React.language("other")
            },
            APP_CATE: {
                OFFICE: "office",
                HR: "hr",
                CRM: "crm",
                INVENTORY: "inventory",
                STORE: "store",
                PRODUCTION: "production",
                UNIVERSAL_OTHER: "universal_other",
                LOGISTICS: "logistics",
                RESTAURANT: "restaurant",
                IT: "it",
                HOUSING: "housing",
                EDUCATION: "education",
                MEDICINE: "medicine",
                GOVERNMENT: "government",
                VERTICAL_OTHER: "vertical_other"
            },
            QN_BUCKET: {
                PUBLIC_IMAGE: "media",
                PRIVATE_FILE: "file",
            },
            OSS_BUCKET: {
                PUBLIC_IMAGE: "oss_image"
            },
            MANAGE_GROUP: {
                SYS: {
                    ID: -1,
                    NAME: React.language("manage.group.system.name")
                }
            },
            WORKFLOW: {
                NODE_DELIMITER: "@",
                START_FLOW_ID: 0,
                END_FLOW_ID: -1,
                APPROVAL_ALL: 0,
                APPROVAL_AT_ONCE: -1,
                BACKRULE: {
                    DISALLOW: 0,
                    PARENT_NODE: 1,
                    START_NODE: 2,
                    RANG_NODE: 3,
                },
                FLOWSTATE: {
                    INPROCESS: 0,
                    COMPLETE: 1,
                    CLOSE: 2,
                },
                FLOWTYPE: {
                    NORMAL: "flow",
                    CC: "cc",
                    SUBFLOW: "subflow",
                },
                CREATOR_ID: "100000000000000000000000",
                DEPT_MANAGER_ID: "110000000000000000000000",
                CHARGER_ID: "111000000000000000000000",
                CHARGER_DEPT_MANAGER_ID: "111100000000000000000000"
            },
            FlOW_SCHEDULE: {
                TIME_LIMIT: {
                    CUSTOM: "custom",
                    WIDGET: "widget"
                },
                ACTION_OP: {
                    NOTIFY: "notify",
                    FORWARD: "forward",
                    BACK: "back"
                },
                DEFAULT_OFFSET: 1,
                MIN_OFFSET: 1,
                MAX_OFFSET: {
                    m: 43200,
                    h: 720,
                    d: 30
                },
                DEFAULT_DAY_TIME: "09:00",
                MAX_ACTIONS_COUNT: 5
            },
            DEPT_ID: {
                CURRENT: "110000000000000000000001",
                CURRENT2: "110000000000000000000012",
                CURRENT3: "110000000000000000000013",
                CURRENT4: "110000000000000000000014",
                CURRENT5: "110000000000000000000015",
                CURRENT_SUBDEPT: "110000000000000000000002",
                CURRENT_PARDEPT: "110000000000000000000003",
                CURRENT_PARDEPTS: "110000000000000000000004" //指定父级部门
            },
            PARAMETER: {
                EMPTY: "fx_param_empty"
            },
            TEXT_TYPE_REGEXP: {
                interMobile: "^\\+?(\\d{2,3}-)?\\d{7,}$",
                mobile: "^((\\(\\d{2,3}\\))|(\\d{3}\\-))?1\\d{10}$",
                tel: "^(0[0-9]{2,3}\\-)?([2-9][0-9]{6,7})+(\\-[0-9]{1,4})?$",
                zip: "^\\d{6}$",
                email: "^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$",
                URL: "(?:http(?:s)?:\\/\\/|www)[\\w.]+(?:[\\w\\-\\.,?=%:&/\\+#]*[\\w\\-\\?=%:&/\\+#@])+",
                ID: "(^\\d{15}$)|(^\\d{18}$)|(^\\d{17}(\\d|X|x)$)",
                HM: "(^[0-1]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$|^[2]{1}[0-3]{1}:[0-5]{1}[0-9]{1}$|^[0-9]{1}:[0-5]{1}[0-9]{1}$)", //时间 时分
                HMS: "(^[0-1]{1}[0-9]{1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$|^[2]{1}[0-3]{1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$|^[0-9]{1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$)", //时间 时分秒
            },
            ORDER_STATE: {
                CANCELED: -1,
                UNPAID: 0,
                PAID: 1,
                RECEIPTING: 2,
                RECEIPTED: 3
            },
            WX_ENHANCE_LEVEL: {
                OFF: 0,
                SILENCE: 1,
                POPUPS: 2
            },
            FIELD: {
                SUBFORM_DELIMITER: ".",
                DELIMITER: "@",
                ENTRY_DELIMITER: "#",
                FORMULA_FIELD_DELIMITER: "$"
            },
            FILTER_VALUE_MODE: {
                CUSTOM: "custom",
                ITEM: "item",
                INPUT: "input",
            },
            DASH_CHART_THEME_TEXT_MAP: {
                default: React.language("default"),
                preset_1: React.language("dash.color.custom00"),
                preset_2: React.language("dash.color.custom01"),
                preset_3: React.language("dash.color.custom02"),
                preset_4: React.language("dash.color.custom03"),
                preset_5: React.language("dash.color.custom04"),
                preset_6: React.language("dash.color.custom05"),
                preset_7: React.language("dash.color.custom06"),
                preset_8: React.language("dash.color.custom07"),
                preset_9: React.language("dash.color.custom08"),
                preset_10: React.language("dash.color.custom09"),
                preset_map_1: React.language("dash.color.customMap01"),
                preset_map_2: React.language("dash.color.customMap02"),
                preset_map_3: React.language("dash.color.customMap03"),
                preset_map_4: React.language("dash.color.customMap04"),
                preset_map_5: React.language("dash.color.customMap05"),
                preset_map_6: React.language("dash.color.customMap06"),
                preset_map_7: React.language("dash.color.customMap07")
            },
            DASH_CHART_THEME: [{
                value: "preset_1",
                colors: ["#EC5F02", "#FF9B3B", "#D6A77C", "#B61804", "#8A1301", "#418EC1", "#FECCD6", "#F76269", "#E55B5F", "#E14C5E"]
            }, {
                value: "preset_2",
                colors: ["#495D9E", "#B1C6DF", "#DAF68C", "#B4DB3F", "#7BAB17", "#547D15", "#FEF762", "#F7DC30", "#D3C04F", "#867B5A"]
            }, {
                value: "preset_3",
                colors: ["#F1E4D0", "#DBCA0A", "#B9916E", "#B95F64", "#FD965A", "#E8E8D2", "#689B9C", "#C68B16", "#826D63", "#F8B48D"]
            }, {
                value: "preset_4",
                colors: ["#5E7F50", "#BFD971", "#FDE975", "#FF8952", "#930100", "#FDA9C1", "#FEDAC6", "#54C09D", "#F2855B", "#F9C393"]
            }, {
                value: "preset_5",
                colors: ["#87D5EF", "#69C5E6", "#496ED0", "#BB89EE", "#6C43AA", "#518FA5", "#374354", "#52559F", "#A658BA", "#BC77CE"]
            }, {
                value: "preset_6",
                colors: ["#FF9B88", "#FFD543", "#5BD4D6", "#74A1F7", "#CCD8E2", "#8E72C0", "#4081BE", "#A7E2E9", "#91B9FF", "#365373"]
            }, {
                value: "preset_7",
                colors: ["#4BB190", "#5A85AB", "#BFBFBF", "#9DD7C4", "#278466", "#C1DAF0", "#446078", "#E9E9E9", "#4A9B9B", "#95E0F0"]
            }, {
                value: "preset_8",
                colors: ["#00A6EF", "#005297", "#30DEC0", "#A7E2E9", "#4081BE", "#CCD8E2", "#365373", "#00C4AF", "#C1DAF0", "#259A8D"]
            }, {
                value: "preset_9",
                colors: ["#FF8400", "#FFE05A", "#2B76D4", "#00CCAD", "#FFA700", "#00B1CC", "#5E58D5", "#1AE685", "#F9CE3A", "#25756C"]
            }, {
                value: "preset_10",
                colors: ["#9DD973", "#5BD9D9", "#F2B05E", "#F2EDA2", "#F26B83", "#B2A7D9", "#F2E966", "#49BF9E", "#F2836B", "#85B6F2"]
            }],
            ColorScheme: {
                "classic": ["#EC5F02", "#FF9B3B", "#D6A77C", "#B61804", "#8A1301", "#418EC1", "#FECCD6", "#F76269", "#E55B5F", "#E14C5E"],
                "fashion": ["#495D9E", "#B1C6DF", "#DAF68C", "#B4DB3F", "#7BAB17", "#547D15", "#FEF762", "#F7DC30", "#D3C04F", "#867B5A"],
                "BrightSun": ["#F1E4D0", "#DBCA0A", "#B9916E", "#B95F64", "#FD965A", "#E8E8D2", "#689B9C", "#C68B16", "#826D63", "#F8B48D"],
                "grace": ["#5E7F50", "#BFD971", "#FDE975", "#FF8952", "#930100", "#FDA9C1", "#FEDAC6", "#54C09D", "#F2855B", "#F2855B"],
                "modern": ["#87D5EF", "#69C5E6", "#496ED0", "#BB89EE", "#6C43AA", "#518FA5", "#374354", "#52559F", "#A658BA", "#BC77CE"]
            },
            DASH_CHART_MAP_THEME: [{
                value: "preset_map_1",
                colors: ["#B5E9F5", "#0361E5"]
            }, {
                value: "preset_map_2",
                colors: ["#89C4E8", "#EC2F4B"]
            }, {
                value: "preset_map_3",
                colors: ["#A4EBB3", "#04BAF3"]
            }, {
                value: "preset_map_4",
                colors: ["#DFECC1", "#E9272B"]
            }, {
                value: "preset_map_5",
                colors: ["#88E1EB", "#5B25B8"]
            }, {
                value: "preset_map_6",
                colors: ["#F0EBB6", "#0CAB39"]
            }, {
                value: "preset_map_7",
                colors: ["#7FE7C6", "#0251A1"]
            }],
            DASH_CHART_TITLE_DELIMITER: "/",
            FIELD_WIDTH: {
                FIVE: "five",
                FOUR: "four",
                THIRD: "third",
                HALF: "half",
                NORMAL: "normal",
                TWICE: "twice",
                CUSTOM: "custom"
            },
            GanttMode: [
                'Year',
                'Quarterly',
                'Month',
                'Quarterly Month',
                'Week',
                'Day',
                'Half Day',
                'Hour',
            ],
            GanttModeName: [
                React.language('Year'),
                React.language('Quarterly'),
                React.language('Month'),
                React.language('Quarterly Month'),
                React.language('Week'),
                React.language('Day'),
                React.language('Half Day'),
                React.language('Hour'),
            ],
            AUTH_GROUP: {
                SUBMIT: -1,
                VIEW_ALL: -2,
                MANAGE_OWN: -3,
                MANAGE_ALL: -4
            },
            AUTH_GROUP_CONTENT: [{
                groupId: -1,
                name: React.language("auth.group.submit.name"),
                desc: React.language("auth.group.submit.description"),
                type: "default"
            }, {
                groupId: -4,
                name: React.language("auth.group.manage.name"),
                desc: React.language("auth.group.manage.description"),
                type: "default"
            }, {
                groupId: -3,
                name: React.language("auth.group.manageOwn.name"),
                desc: React.language("auth.group.manageOwn.description"),
                type: "default"
            }, {
                groupId: -2,
                name: React.language("auth.group.review.name"),
                desc: React.language("auth.group.review.description"),
                type: "default"
            }],
            FLOW_AUTH_GROUP_CONTENT: [{
                groupId: -1,
                name: React.language("flow.launch"),
                desc: React.language("flow.auth.group.submit.description"),
                type: "default"
            }, {
                groupId: -4,
                name: React.language("flow.auth.group.manage.name"),
                desc: React.language("flow.auth.group.manage.description"),
                type: "default"
            }, {
                groupId: -2,
                name: React.language("flow.auth.group.review.name"),
                desc: React.language("flow.auth.group.review.description"),
                type: "default"
            }],
            REPORT_AUTH_GROUP_CONTENT: [{
                groupId: -4,
                name: React.language("auth.group.manage.name"),
                desc: React.language("auth.group.manage.description"),
                type: "default"
            }, {
                groupId: -3,
                name: React.language("auth.group.manageOwn.name"),
                desc: React.language("auth.group.manageOwn.description"),
                type: "default"
            }, {
                groupId: -2,
                name: React.language("auth.group.review.name"),
                desc: React.language("auth.group.review.description"),
                type: "default",
                members: ["111000000000000000000001"]
            }],
            APP_STATE: {
                private: 0,
                review: 1,
                onSale: 2
            },
            K12_APPROVE: {
                NOTPASS: -1,
                PASS: 1
            },
            VIP_MODULE: {
                USERS: "users",
                FORM_DATA: "form_data",
                DATA: "data",
                EXCEL_IMPORT: "excel_import",
                SINGLE_FILE: "single_file",
                FILE_UPLOAD: "file_upload",
                AGGREGATE: "aggregate",
                PRINT: "print",
                DATA_BACKUP: "data_backup",
                FILE_ZIP: "file_zip",
                LOGO: "logo",
                SUBMIT_PROMPT: "level",
                CUSTOM_THEME: "diy_theme",
                USER_SYNC: "user_sync",
                APP_BRIDGE: "app_bridge",
                LEVEL: "level",
                MODULE_NUM: "module_num",
                DATAHELPER_NUM: "datahelper_num",
                SCHEDULE_NUM: "schedule_num"
            },
            VIP_COOKIE: {
                TRAIL: {
                    SUFFIX_KEY: "#tr_time",
                    EXPIRES_DATE: new Date((new Date()).getTime() + 1296e6)
                },
                SYS_DATA: {
                    KEY: "exceed",
                    EXPIRES_DATE: new Date((new Date()).getTime() + 864e5),
                    VALUE: !0
                }
            },
            WPS_TIP: {
                7102: React.language("WPSTIP.7102"),
                7103: React.language("WPSTIP.7102"),
                7104: React.language("WPSTIP.7104"),
                7105: React.language("WPSTIP.7105"),
                7106: React.language("WPSTIP.7106"),
                7107: React.language("WPSTIP.7107"),
                7108: React.language("WPSTIP.7108"),
                7109: React.language("WPSTIP.7109"),
                7110: React.language("WPSTIP.7110"),
                7111: React.language("WPSTIP.7111")
            },
            TRACKER: {
                APP_CREATE: "app_create",
                APP_FORK: "app_fork",
                APP_EDIT: "app_edit",
                APP_CONFIG: "app_config",
                APP_REF: "app_ref",
                APP_ETL_NODE_RENAME: "app_etl_node_rename",
                APP_ETL_OUTPUT_RENAME: "app_etl_output_rename",
                MEMBER_INVITE: "member_invite",
                AUTH_GROUPS: "auth_groups",
                APP_ETL_LOG_VIEW: "app_etl_log_view",
                AGGREGATE_TABLE_CREATE: "aggregate_table_create",
                APP_ETL_EDIT: "app_etl_edit",
                APP_ETL_REMOVE: "app_etl_remove",
                APP_ETL_OUTPUT_VIEW: "app_etl_output_view",
                APP_ETL_EXECUTE: "app_etl_execute",
                APP_ETL_CREATE: "app_etl_create",
                AGGREGATE_TABLE_EDIT: "aggregate_table_edit",
                MEMBER_ASYNC_FROM_WECHAT: "member_async_from_wechat",
                SUBMIT_PROMPT_SAVE: "submit_prompt_save",
                SUBMIT_PROMPT_ON: "submit_prompt_on",
                FORM_CREATE: "form_create",
                MEMBER_INVITE_LINK_CLICK: "member_invite_link_click",
                FORM_EDIT: "form_edit",
                FORM_FIELD_ADD: "form_field_add",
                FORM_FIELD_RENAME: "form_field_rename",
                FLOW_FORM_FIELD_RENAME: "flow_form_field_rename",
                FLOW_FORM_FIELD_ADD: "flow_form_field_add",
                REPORT_CREATE: "report_create",
                REPORT_EDIT: "report_edit",
                ORDER_LIST: "order_list",
                VIP_CENTER: "vip_center",
                WORKFLOW: "workflow",
                MENU_PACK: "menu_pack",
                VIP_CENTER_PACK: "vip_center_pack",
                MEMBER_LIST: "member_list",
                HELP_DOC: "help_doc",
                HELP_VIDEO: "help_video",
                HELP_CUSTOM: "help_custom",
                TEMP_SEARCH: "temp_search",
                APP_VIEW: "app_view",
                OPTION_WIDGET_COLOR_ENABLE: "option_widget_color_enable",
                OPTION_WIDGET_COLOR_CLOSE: "option_widget_color_close",
                PRINT_CREATE: "print_create",
                FORM_SHARE: "form_share",
                FLOW_FORM_CREATE: "flow_form_create",
                AUTH_GROUP_CREATE: "auth_group_create",
                DASH_CUSTOM_SORT_CLICK: "dash_custom_sort_click",
                DASH_CUSTOM_SORT_SAVE: "dash_custom_sort_save",
                DASH_CALENDAR_DATE_SELECT: "dash_calendar_date_select",
                DASH_COPY_WIDGET: "dash_copy_widget",
                DASH_CREATE: "dash_create",
                DASH_COPY: "dash_copy",
                DASH_EDIT_PAGE_VISIT: "dash_edit_page_visit",
                DASH_RENAME: "dash_rename",
                DASH_PREVIEW: "dash_preview",
                DASH_PUBLISH: "dash_publish",
                DASH_SHARE_TO_MEMBER: "dash_share_to_member",
                DASH_REF: "dash_ref",
                DASH_SAVE: "dash_save",
                DASH_CHART_ADD: "dash_chart_add",
                DASH_CHART_CREATE: "dash_chart_create",
                DASH_DIMENSION_ADD: "dash_dimension_add",
                DASH_QUOTA_ADD: "dash_quota_add",
                DASH_METRIC_TABLE_SAVE: "dash_metric_table_save",
                DASH_GAUGE_CHART_SAVE: "dash_gauge_chart_save",
                DASH_PIVOT_TABLE_SAVE: "dash_pivot_table_save",
                DASH_BAR_CHART_SAVE: "dash_bar_chart_save",
                DASH_COLUMN_CHART_SAVE: "dash_column_chart_save",
                DASH_LINE_CHART_SAVE: "dash_line_chart_save",
                DASH_AREA_CHART_SAVE: "dash_area_chart_save",
                DASH_PIE_CHART_SAVE: "dash_pie_chart_save",
                DASH_RADAR_CHART_SAVE: "dash_radar_chart_save",
                DASH_MULTI_AXES_CHART_SAVE: "dash_multi_axes_chart_save",
                DASH_MAP_CHART_SAVE: "dash_map_chart_save",
                DASH_TABLE_ADD: "dash_table_add",
                DASH_TABLE_CREATE: "dash_table_create",
                DASH_FIELD_ADD: "dash_field_add",
                DASH_FIELD_GROWTH_SET: "dash_field_growth_set",
                DASH_TABLE_SAVE: "dash_table_save",
                DASH_MANAGE_ADD: "dash_manage_add",
                DASH_DATA_MANAGE_SELECT: "dash_data_manage_select",
                DASH_CALENDAR_SELECT: "dash_calendar_select",
                DASH_MANAGE_DATA_SOURCE_SELECT: "dash_manage_data_source_select",
                DASH_DATA_MANAGE_CREATE: "dash_data_manage_create",
                DASH_CALENDAR_CREATE: "dash_calendar_create",
                DASH_FILTER_ADD: "dash_filter_add",
                DASH_FILTER_CHART_SELECT: "dash_filter_chart_select",
                DASH_FILTER_FIELD_SELECT: "dash_filter_field_select",
                DASH_FILTER_CREATE: "dash_filter_create",
                DASH_FILTER_BTN_ADD: "dash_filter_btn_add",
                DASH_WIDGET_ADD: "dash_widget_add",
                DASH_TOP_DATA_CHECKED: "dash_top_data_checked",
                DASH_ROW_ORDER_CHECKED: "dash_row_order_checked",
                DASH_LABEL_ROTATION_CHANGE: "dash_label_rotation_change",
                DASH_SHOW_LABEL_CHECKED: "dash_show_label_checked",
                DASH_NOTIFY_ENABLED: "dash_notify_enabled",
                DASH_NOTIFY_SAVE: "dash_notify_save",
                DASH_THRESHOLD_ADD: "dash_threshold_add",
                DASH_THRESHOLD_SAVE: "dash_threshold_save",
                DASH_THRESHOLD_ON: "dash_threshold_on",
                DASH_THRESHOLD_OFF: "dash_threshold_off",
                DASH_THRESHOLD_REMOVE: "dash_threshold_remove",
                DASH_GUIDELINE_ADD: "dash_guideline_add",
                DASH_GUIDELINE_SAVE: "dash_guideline_save",
                DASH_COLOR_ADD: "dash_color_add",
                DASH_COLOR_SAVE: "dash_color_save",
                DASH_VALUE_SIZE_CHANGE: "dash_value_size_change",
                DASH_RANGE_CHANGE: "dash_range_change",
                DASH_CHART_LABEL_CANCELED: "dash_chart_label_canceled",
                DASH_LEGEND_CANCELED: "dash_legend_canceled",
                DATA_MANAGE_IMPORT: "data_manage_import",
                DATA_MANAGE_IMPORT_FILE_SELECT: "data_manage_import_file_select",
                DATA_MANAGE_IMPORT_NEXT_PREVIEW: "data_manage_import_next_preview",
                DATA_MANAGE_IMPORT_NEXT_SET: "data_manage_import_next_set",
                DATA_MANAGE_IMPORT_DONE: "data_manage_import_done",
                DATA_MANAGE_EXPORT: "data_manage_export",
                DATA_MANAGE_EXPORT_DONE: "data_manage_export_done",
                DATA_MANAGE_BATCH_EDIT: "data_manage_batch_edit",
                DATA_MANAGE_BATCH_EDIT_RANGE: "data_manage_batch_edit_range",
                DATA_MANAGE_BATCH_EDIT_FIELD: "data_manage_batch_edit_field",
                DATA_MANAGE_BATCH_EDIT_FIXED: "data_manage_batch_edit_fixed",
                DATA_MANAGE_BATCH_EDIT_FORMULA: "data_manage_batch_edit_formula",
                DATA_MANAGE_BATCH_EDIT_VALUE: "data_manage_batch_edit_value",
                DATA_MANAGE_BATCH_EDIT_DONE: "data_manage_batch_edit_done",
                DATA_MANAGE_BATCH_PRINT: "data_manage_batch_print",
                DATA_MANAGE_BATCH_PRINT_SELECT: "data_manage_batch_print_select",
                DATA_MANAGE_FILE_EXPORT: "data_manage_file_export",
                DATA_MANAGE_FILE_LINK: "data_manage_file_link",
                DATA_MANAGE_FILE_DOWNLOAD: "data_manage_file_download",
                DATA_MANAGE_BATCH_QRCODE: "data_manage_batch_qrcode",
                DATA_MANAGE_BATCH_QRCODE_RANGE: "data_manage_batch_qrcode_range",
                DATA_MANAGE_BATCH_QRCODE_DONE: "data_manage_batch_qrcode_done",
                DATA_MANAGE_TRANSFER: "data_manage_transfer",
                DATA_MANAGE_TRANSFER_RANGE: "data_manage_transfer_range",
                DATA_MANAGE_TRANSFER_CHARGER: "data_manage_transfer_charger",
                DATA_MANAGE_TRANSFER_NEW_CHARGER: "data_manage_transfer_new_charger",
                DATA_MANAGE_TRANSFER_DONE: "data_manage_transfer_done",
                DATA_MANAGE_FLOW_CLOSE: "data_manage_flow_close",
                DATA_MANAGE_FLOW_CLOSE_RANGE: "data_manage_flow_close_range",
                DATA_MANAGE_FLOW_CLOSE_DONE: "data_manage_flow_close_done",
                DATA_AUTH_MOBILE_LAYOUT: "data_auth_mobile_layout",
                DATA_AUTH_TEAM_VISIT_LINK: "data_auth_team_visit_link",
                DATA_AUTH_PRINT_SET: "data_auth_print_set",
                DATA_AUTH_EDIT: "data_auth_edit",
                DATA_AUTH_REMOVE: "data_auth_remove",
                DATA_AUTH_MEMBER_ADD: "data_auth_member_add",
                DATA_AUTH_MEMBER_EDIT: "data_auth_member_edit",
                DATA_COPY_ADMIN: "data_copy_admin",
                DATA_COPY_VIEW: "data_copy_view",
                DATA_COPY_SUBMIT: "data_copy_submit",
            },
            KEY_CODE: {
                LEFT: 37,
                RIGHT: 39,
                BACKSPACE: 8,
                DELETE: 46,
                ENTER: 13,
                ESC: 27,
            },
            ALLIANCE_APPLY_STATE: {
                APPROVED: "approved",
                WAITING: "waiting",
                DENIED: "denied",
                NOT_APPLIED: "not_applied",
                BANNED: "banned"
            },
            UPLOAD_FILE_COUNT: {
                SINGLE: 1,
                MULTI: 50
            },
            FILTER_METHOD: {
                EQ: "eq",
                NE: "ne",
                ALL: "all",
                IN: "in",
                BIN: "bin",
                NIN: "nin",
                LK: "like",
                ULK: "unlike",
                EP: "empty",
                NEP: "not_empty",
                GT: "gt",
                GTE: "gte",
                LT: "lt",
                LTE: "lte",
                RG: "range",
                VF: "verified",
                NVF: "unverified",
                FM: "formula",
                FT: "filter"
            },
            ORDER_METHOD: {
                ASC: "ASC",
                DESC: "DESC"
            },
            MOBILE_MENU_MODE: {
                FORMLIST: 0, //默认表单列表模式
                FORMVIEW: 1, //列表查看模式
                FLOWTODO: 2 //流程待办
            },
            MOBILE_SYS_LIST_MODE: {
                DEFAULT: 0, //默认传统列表模式 类似微信
                BLOCK: 1, //九宫格模式
            },
            MODULE_MODE: {
                DATASUBMIT: 1, //数据提交
                DATAEDIT: 2, //数据编辑
                DATADELETE: 3, //数据删除
                DATAINIT: 4, //数据初始化
                EVENT: 5, //控件触发
                TIMER: 6, //定时任务
                FLOWSUBMIT: 7, //流程模块
            }
        }


    }
}